import React, { useState } from "react";
import {
    Button,
    Modal,
    Form,
    Input,
    Select,
    DatePicker,
    Upload,
    message,
  Tooltip,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";

import { useParams } from "react-router-dom";

import useCandidateStore from "../../store/candidateModal.store";
import useResumeStore from "../../store/resume.store";
import { API_URL } from "../../helper/axioscontants";
import { DeleteOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import "./candidateAddModal.scss";

const defaultInput = {
    name: "",
    mobile: "Not Needed",
    email: "Not Needed",
    tags: "",
    resumesource: "",
    resumedate: "",
};

export default function CandidateAddModal() {
    const types = ["application/pdf"];
    const [formInput, setFormInput] = useState(defaultInput);
    const [currentMsg, setResponse] = useState("No Error");
    const [fileList, setFileList] = useState([]);
    const [deleteAll, setDeleteAll] = useState(false);
    const { value } = useParams();
    const { getResumesByJD,setUpdateFlag,updateFlag,getAllApplicationsByJD   } = useResumeStore();
    const { isCandidateModalOpen, handleModalOk, handleModalCancel } =
        useCandidateStore();

    const [form] = Form.useForm(); 
    
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    const baseURL = API_URL;
    
    const props = {
        accept:"pdf",
        showUploadList: true,
        name: "pdf",
        action: `${baseURL}/addresume/${userDetails.qhoid}/${userDetails.qhuid}/jds/${value}`,
        multiple: true,
        maxCount: 20,
        fileList,
        data: {
            mobile: "Not Needed",
            email: "Not Needed",
            tags: formInput?.tags,
            resumesource: formInput?.resumesource,
            resumedate: formInput?.resumedate
        },
        beforeUpload(file) {
        // Check for Resume Source first
        if (!formInput.resumesource) {
            message.warning("Please select a Resume Source before uploading.");
            return Upload.LIST_IGNORE; // Stops the upload process
        }
        if (!formInput.resumedate) {
            message.warning("Please select a Resume Date before uploading.");
            return Upload.LIST_IGNORE; // Stops the upload process
        }

        if (!types.includes(file.type)) {
            message.error(`${file.name} is not a pdf file`);
            return Upload.LIST_IGNORE;
        }

        const maxFileSize = 5 * 1024 * 1024; // 5MB limit
        if (file.size > maxFileSize) {
            message.error(`${file.name} file upload failed (exceeds 5MB)`);
            return Upload.LIST_IGNORE;
        }
        return true;
        },
    onChange(info) {
      if (info.fileList.length > 0) {
        setDeleteAll(true);
        setFileList(info.fileList);
      } else {
        setDeleteAll(false);
      }
            if (info.file.status !== "uploading") {
                //console.log(info);
            }
            if (info.file.status === "done") {
                //response: '{"status": "success"}', // response from server
                message.success(`${info.file.name} file uploaded successfully`);                        
            } else if (info.file.status === "error") {
                //now check if 
                // 1. Resume already exists for this JD by the same user ID
                // 2. Resume already exists for this JD byt other user ID
                // 3. Resume already exist for this JD
                var responseData = info.file.response
                if(responseData.error == "DUPLICATE_UPLOADED_VENDOR"){
                    message.error(`${info.file.name} Duplicate, Uploaded by Another Vendor`);
                }else if(responseData.error == "DUPLICATE_UPLOADED_TEAM"){
                    message.error(`${info.file.name} Duplicate, Already Assigned to this JD`);
                }else if(responseData.error == "DUPLICATE_UPLOADED_JOBSEARCH"){
                    message.error(`${info.file.name} Duplicate, Already Assigned to this JD`);
                }else if(responseData.error == "DUPLICATE_UPLOADED_CAREERPAGES"){
                    message.error(`${info.file.name} Duplicate, Already Assigned to this JD`);
                }else if(responseData.error == "DUPLICATE_UPLOADED_FORMLINK"){
                    message.error(`${info.file.name} Duplicate, Already Assigned to this JD`);
                }else if(responseData.error == "NO_EMAIL_IN_RESUME"){
                    message.error(`${info.file.name} No Email in the resume`);
                }                
                //handleModalOk();
                setResponse(responseData.error)
                form.resetFields(); 
            }
            const { fileList } = info;

            // ✅ Check if all uploads are done or failed
            const allDone = fileList?.every(
                (file) => file.status === "done" || file.status === "error"
                ); 
            if (allDone) {
                //console.log("✅ All uploads complete");
                //message.success("All files have finished uploading!");
                //hack to avoid multiple calling...
                if(!updateFlag){
                    setUpdateFlag();   
                }                    
                //handleModalOk();  
                form.resetFields();
            }                   
        },
        itemRender(originNode, file) {
            return (
            <div style={{ marginBottom: 10 }}>
                {originNode}
                {file.status === "done" && file.response && (
                <div style={{ color: "green", marginTop: 4 }}>
                    ✅ {file.response.status}
                </div>
                )}
                {file.status === "error" && (
                <div style={{ color: "red", marginTop: 4 }}>❌ {file.response.error}</div>
                )}
            </div>
            );
        },
    }
    const OnSelectChangeResume = (value) => {
        console.log("selected",value);
        //if(status === "Available"){
        //    handleResumeDetailClick(data[idxInt].qhid)
        //}
        
        setFormInput((inputs) => ({
            ...inputs,["resumesource"]: value,
        }));
    }

    const OnDateChange = (date, dateString) => {
        console.log("selected date", date, dateString);
        setFormInput((inputs) => ({
            ...inputs,["resumedate"]: dateString || null,
        }));
    }
    
    const handleFormInput = (event) => {
        setFormInput((inputs) => ({
            ...inputs,
            [event.target.name]: event.target.value,
        }));
    };

    return (
        <Modal
            title="Upload Resume in QuallyHire"
            open={isCandidateModalOpen}
            name="candidateAddModal"    
            footer={null}
            onCancel={() => {
                handleModalCancel();
                setFileList([]);
                setFormInput(defaultInput);
                form.resetFields();
      }}
        >
            <Form
                labelCol={{ flex: "150px" }}
                form={form}
                labelAlign="left"
                labelWrap
                wrapperCol={{ flex: 1 }}
                colon={false}
                name="candidateAddModalForm"
            >
                <Form.Item
                    label="Skills"
                    name="tags"
                >
                    <Input
                        name="tags"
                        value={formInput.tags}
                        onChange={handleFormInput}
                        placeholder={"skill1,..., skill N etc."}                        
                        className="candidateAddModel-input"
                    />
                </Form.Item>    
                <Form.Item
                                rules={[{ required: true, message: "Resume Source is required!" }]}
                                name="resumesource"
                                className="candidateAddModel-input"
                                label="Resume source"
                            >
                                    <Select                       
                                        required={true}
                                        name="resumesource"
                                        className="candidateAddModel-input" 
                                        onChange={OnSelectChangeResume}                               
                                       value={formInput.resumesource}
                                        options={[
                                            { value: 'Naukri', label: 'Naukri' },
                                            { value: 'Foundit', label: 'Foundit' },
                                            { value: 'Company DB', label: 'Company DB' },
                                            { value: 'QuallyHire DB', label: 'QuallyHire DB' },
                                            { value: 'Employee Referral', label: 'Employee Referral'},
                                            { value: 'Bulk Mail Naukri', label: 'Bulk Mail Naukri' },
                                            { value: 'Candidate Referral', label: 'Candidate Referral' },
                                            { value: 'Linkedin Job Post', label: 'Linkedin Job Post' },
                                            { value: 'Naukri Job Post', label: 'Naukri Job Post' },
                                            { value: 'Other Job Posts', label: 'Other Job Posts'},
                                            { value: 'From Partners', label: 'From Partners'},
                                        ]}
                                    />                         
                </Form.Item>                                                              
                <Form.Item
                                rules={[{ required: true, message: "Date is required!" }]}
                                name="resumedate"
                                className="candidateAddModel-input"
                                label="Resume Date"
                            >
                                    <DatePicker
                                        name="resumedate"
                                        picker="month"   // 👈 IMPORTANT
                                        format="MM-YYYY"
                                        placeholder="Select Date"
                                        onChange={OnDateChange}
                                        value={formInput.resumedate? dayjs(formInput.resumedate, "MM-YYYY"): null }
                                    />
                </Form.Item> 
        <div className="candidateAddModel-btns">
          <Upload {...props}>
            <Tooltip
              title={
                formInput.resumesource !="" || formInput.resumedate !="" ? null : "Please select a Resume Source and Date"
              }
              placement="bottom"
              color="white"
              styles={{
                body: {
                  backgroundColor: "white",
                  color: "black",
                  borderRadius: "4px",
                  border: "1px solid #d9d9d9",
                },
              }}
            >
              <Button
                icon={<UploadOutlined />}
                disabled={!formInput.resumesource || !formInput.resumedate}
              >
                Click to Upload
              </Button>
            </Tooltip>
          </Upload>
          <Button
            disabled={!deleteAll}
            onClick={() => {
              setFileList([]);
              setDeleteAll(false);
            }}
          >
            <DeleteOutlined />
          </Button>
        </div>
      </Form>
    </Modal>
  );
}
